export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_masterCategoryCode') || '产品类别',
    field: 'masterCategoryCode',
    minWidth: 170,
    align: 'center',
    slots: { default: 'masterCategoryCode' },
  },
  {
    title: that.$l('table_label_estimated_quantity') || '预计数量',
    field: 'estimatedQty',
    minWidth: 140,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_subBudget') || '预算小计',
    field: 'subBudget',
    minWidth: 140,
    align: 'center',
    slots: { default: 'subBudget' },
  },
  {
    title: that.$l('table_label_first_quarter_budget') || '一季度预算',
    field: 'budgetQ1',
    minWidth: 140,
    align: 'center',
    formatter: ({ row }) => {
      const { budgetQ1: value } = row
      return that.format(value)
    },
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_second_quarter_budget') || '二季度预算',
    field: 'budgetQ2',
    minWidth: 140,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
    formatter: ({ row }) => {
      const { budgetQ2: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_third_quarter_budget') || '三季度预算',
    field: 'budgetQ3',
    minWidth: 140,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
    formatter: ({ row }) => {
      const { budgetQ3: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_fourth_quarter_budget') || '四季度预算',
    field: 'budgetQ4',
    minWidth: 140,
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
    formatter: ({ row }) => {
      const { budgetQ4: value } = row
      return that.format(value)
    },
  }
]
